/**
 * Landing page image manifest — WebP assets sized for on-screen display.
 * Regenerate with: npm run optimize:landing-images
 */

import mainScreenImage from '../../images/landing/main_screen.webp';
import exportRecordsImage from '../../images/landing/export_records.webp';
import screen1 from '../../images/landing/screen_1.webp';
import screen2 from '../../images/landing/screen_2.webp';
import screen3 from '../../images/landing/screen_3.webp';
import screen4 from '../../images/landing/screen_4.webp';
import screen5 from '../../images/landing/screen_5.webp';
import screen6 from '../../images/landing/screen_6.webp';

import slide1 from '../../images/welcome/first-slide.webp';
import slide2 from '../../images/welcome/second-slide.webp';
import slide3 from '../../images/welcome/welcomeDog3.webp';
import slide4 from '../../images/welcome/welcome-documents.webp';
import slide5 from '../../images/welcome/welcome-dairy.webp';
import slide6 from '../../images/welcome/welcome-team.webp';
import slide7 from '../../images/welcome/welcome-family.webp';
import slide8 from '../../images/welcome/welcome-medical-card.webp';

export const LANDING_HERO_IMAGE = mainScreenImage;

export const LANDING_EXPORT_IMAGE = exportRecordsImage;

export const LANDING_FEATURE_SCREENS = [
  { key: 'screen1', image: screen1 },
  { key: 'screen2', image: screen2 },
  { key: 'screen3', image: screen3 },
  { key: 'screen4', image: screen4 },
  { key: 'screen5', image: screen5 },
  { key: 'screen6', image: screen6 },
];

export const LANDING_SLIDER_IMAGES = [
  slide1,
  slide2,
  slide8,
  slide6,
  slide4,
  slide7,
  slide5,
  slide3,
];

/** Above-the-fold + first slider frame — preload as soon as landing mounts. */
export const LANDING_CRITICAL_IMAGES = [mainScreenImage, slide1];

/** Below-the-fold — warm cache after first paint. */
export const LANDING_DEFERRED_IMAGES = [
  ...LANDING_SLIDER_IMAGES.slice(1),
  ...LANDING_FEATURE_SCREENS.map(({ image }) => image),
  exportRecordsImage,
];
